<template>
    <article>
        <section>
            <h3  class="text-center">REPORTE DE UTILIDAD</h3>
        </section>
        <!-- {{ $route.params }} -->
        <div class="row justify-content-center mt-5 mb-4">
              <b-form-select
                v-model="selectedAlmacen"
                :options="almacenes"
                class="mb-3 col-lg-2"
                value-field="id"
                text-field="name"
                disabled-field="notEnabled"
              >
              </b-form-select>
              <input type="date" v-model="dateInit" name="fechaInicial" class="mt-1 ml-2 form-control col-2">
              <input type="date" v-model="dateEnd" name="fechaFinal" class="mt-1 ml-2 form-control col-2">
              <button class="btn btn-secondary ml-3" @click="getOrders">Buscar</button>
        </div>
        <section>
           {{ totales }}
          <div class="row justify-content-center mt-5 mb-5">
            <div class="col-3 m-2 text-center btn-secondary"><h5>Piezas: {{ totales.totalOfItems}}</h5></div>
            <div class="col-3 m-2 text-center btn-danger"><h5>Compras: $ {{ totales.totalCompra | formatNumberCurrency}}</h5></div>
            <div class="col-3 m-2 text-center btn-info"><h5>Ventas: $ {{ totales.totalVenta | formatNumberCurrency}}</h5></div>
            <div class="col-3 m-2 text-center btn-success"><h5>Utilidad: $ {{ totales.totalUtilidad | formatNumberCurrency}}</h5></div>
          </div>
          <div class="row justify-content-end mb-4 mt-4">
            <jsonExcel :data="vales"
              class="btn btn-secondary"
              :fields= "{
                'Codigo de Barras': 'barcode',
                'Producto': 'producto',
                'Cliente': 'client',
                'Proveedor': 'provider',
                'Precio de venta': 'venta',
                'Precio de compra': 'costo_tienda',
                'Utilidad': 'utility'
              }"
              worksheet=""
              name="Reporte de utilidad.xls"
            >
              Descargar a Excel
            </jsonExcel>
          </div>
                <vue-good-table
                  :columns="columns"
                  :rows="vales"
                  :sort-options="{
                    enabled: true,
                  }"
                  styleClass="vgt-table bordered"
                  :pagination-options="{
                    enabled: true,
                    mode: 'registros',
                    position: 'top',
                    perPage: 15,
                    nextLabel: 'siguiente',
                    prevLabel: 'anterior',
                    rowsPerPageLabel: 'Filas por página',
                    ofLabel: 'de',
                    pageLabel: 'páginas', // for 'pages' mode
                    allLabel: 'Todos',
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'actions'">
                      <button type="button" class="btn btn-secondary" @click="getDetailTicket(props.row)">
                        <font-awesome-icon :icon="['fa', 'eye']"/>
                      </button>
                      &nbsp;
                      &nbsp;
                      <button type="button" class="btn btn-secondary" @click="getDevolutionTicket(props.row)">
                        <font-awesome-icon :icon="['fa', 'print']"/>
                      </button>
                    </span>
                  </template>
                </vue-good-table>
        </section>
        <modal name="detailTicket" :scrollable="true" height="650" class="">
          <div class="text-right">
            <span class="close-modal" @click="$modal.hide('detailTicket')">
              <font-awesome-icon :icon="['fal', 'sliders-v']" />
            </span>
          </div>
          <div class="reset-pass">
            <h2 class="text-center">Detalle de ticket {{ detail.type }}</h2>
            <div class="container col-11 mt-4">
              <div class="">
                <p><b>FOLIO: <span style="color: blue">{{ detail.folio }}</span></b></p>
                <p><b>CLIENTE:  <span style="color: blue">{{ detail.fullName }}</span></b></p>
                <p><b>FECHA DE EMISIÓN:  <span style="color: blue">{{ detail.create_at }}</span></b></p>
                <p><b>ULTIMA ACTUALIZACIÓN:  <span style="color: blue">{{ detail.update_at }}</span></b></p>
              </div>
            </div>
            <div class="container col-11 mt-4">
              <!-- {{ rows.used }} -->
              <b-table
                striped
                selectable
                class="table-adelantazo"
                select-mode="multi"
                selectedVariant="success"
                responsive="sm"
                show-empty
                stacked="md"
                :items="detail.used"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
              >
              <template v-slot:cell(amount)="row">
                  <div align="center" class="history-amount">
                     <span>$ {{row.item.amount | formatNumberCurrency}}</span>
                  </div>
              </template>
              <template v-slot:cell(action)="row">
                  <div align="center" class="history-amount">
                    <button class="btn" @click="print(row)">
                      <font-awesome-icon :icon="['fa', 'print']"/>
                    </button>
                  </div>
                </template>
              </b-table>
            </div>
            <!-- <div class="text-center">
              <button type="submit" class="btn btn-primary text-center" @click="updateInfo">Actualizar</button>
            </div> -->
          </div>
        </modal>
        <ticket :ticket="ticketDeCompra" :enterprise="enterpriseData.name" :print="countPrint" />
        <devolutionTicket :folio="devolutionFolio" :enterprise="enterpriseData.name" :print="countPrintDevolution" :type="devolutionType"/>
    </article>
</template>
<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import { mapGetters } from 'vuex'
import ticket from '../sales/ticket.vue'
import moment from 'moment'
import devolutionTicket from '../sales/devolutionTicket'
import { BTable, BFormSelect } from 'bootstrap-vue'
import JsonExcel from 'vue-json-excel'

export default {
  components: {
    BTable,
    ticket,
    devolutionTicket,
    BFormSelect,
    JsonExcel
  },
  data () {
    return {
      selectedAlmacen: 1,
      devolutions: [],
      vales: [],
      almacenes: [],
      countPrintDevolution: 0,
      devolutionFolio: 0,
      devolutionType: null,
      enterpriseData: [],
      ticketDeCompra: 0,
      dateInit: moment().format('YYYY-MM-DD'),
      dateEnd: moment().format('YYYY-MM-DD'),
      countPrint: 0,
      currentPage: 1,
      perPage: 50,
      pageOptions: [50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      rows: [],
      detail: [],
      columns: [
        {
          label: 'Codigo de Barras',
          field: 'barcode',
          filterOptions: {
            placeholder: 'Codigo',
            enabled: true
          },
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Producto',
          field: 'producto',
          filterOptions: {
            placeholder: 'Producto',
            enabled: true
          },
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Cantidad',
          field: 'quantity',
          filterOptions: {
            placeholder: 'Producto',
            enabled: false
          },
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Cliente',
          field: 'client',
          filterOptions: {
            placeholder: 'Nombre del cliente',
            enabled: true
          },
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Proveedor',
          field: 'provider',
          filterOptions: {
            placeholder: 'Total disponible',
            enabled: true
          },
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Precio de Venta',
          field: 'venta',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Precio de Compra',
          field: 'costo_tienda',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Utilidad x Unidad',
          field: 'utility',
          filterOptions: {
            placeholder: 'Total disponible',
            enabled: false
          },
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Utilidad Total',
          field: 'utility_total',
          filterOptions: {
            placeholder: 'Total disponible',
            enabled: false
          },
          thClass: 'text-center',
          tdClass: 'text-center'
        }
        // {
        //   label: 'Acciones',
        //   field: 'actions',
        //   filterOptions: {
        //     enabled: false
        //   }
        // }
      ],
      fields: [
        { key: 'invoice', label: 'Folio de Venta', sortable: true, sortDirection: 'desc', thClass: 'text-center', tdClass: 'rowTable text-center' }, // cliente
        { key: 'amount', label: 'Monto usado', sortable: true, sortDirection: 'desc', thClass: 'text-center', tdClass: 'rowTable text-center' },
        { key: 'date', label: 'Fecha de aplicacíon', sortable: true, sortDirection: 'desc', thClass: 'text-center', tdClass: 'rowTable text-center' },
        { key: 'action', label: 'Acciones', sortable: false, sortDirection: 'desc', thClass: 'text-center', tdClass: 'rowTable text-center' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    totales () {
      let totalVenta = 0
      let totalCompra = 0
      let totalUtilidad = 0
      let totalOfItems = 0
      this.vales.forEach(el => {
        totalVenta += el.venta * el.quantity
        totalCompra += el.costo_tienda * el.quantity
        totalUtilidad += el.utility_total
        totalOfItems += el.quantity
      })
      return {
        totalCompra,
        totalUtilidad,
        totalVenta,
        totalOfItems
      }
    }
  },
  methods: {
    async getTickets (clientId) {
      try {
        this.rows = []
        const params = {
          enterprise_id: this.user.enterprise_id,
          client_id: clientId,
          dateInit: this.dateInit,
          dateEnd: this.dateEnd
        }
        const response = await axiosAdelaService.post('/getTickets', params)
        console.log('VALES', response)
        if (response.status === 200) {
          const data = response.data
          this.devolutions = data.devolutions
          this.vales = data.vales
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener los almacenes.')
      }
    },
    async getDetailTicket (item) {
      try {
        this.$modal.show('detailTicket')
        const params = {
          enterprise_id: this.user.enterprise_id,
          folio: item.folio,
          type: item.type
        }
        console.log(params, item)
        const response = await axiosAdelaService.post('/getDetailTicket', params)
        console.log(response)
        if (response.status === 200) {
          this.detail = response.data.rows
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener los almacenes.')
      }
    },
    async getOrders () {
      try {
        const request = {
          almacen: this.selectedAlmacen,
          enterprise_id: this.user.enterprise_id,
          dateInit: this.dateInit,
          dateEnd: this.dateEnd
        }
        const orders = await axiosAdelaService.post('/utlity', request)
        console.log('utlity', orders)
        if (orders.status === 200) {
          this.vales = orders.data.rows
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    getDevolutionTicket (arg) {
      console.log('DEVOLUTIUON', arg)
      this.devolutionFolio = arg.folio
      this.devolutionType = arg.type
      setTimeout(() => {
        this.countPrintDevolution++
      }, 3000)
    },
    print (row) {
      console.log('AQUI LA IMPRESION', row)
      this.ticketDeCompra = row.item.invoice
      this.countPrint++
    },
    async getWarehouses () {
      try {
        const request = {
          data: this.user.enterprise_id
        }
        const orders = await axiosAdelaService.post('/getWarehouses', request)
        // console.log('getEnterprisesSelected', orders)
        if (orders.status === 200) {
          this.almacenes = orders.data.rows
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    }
  },
  async mounted () {
    await this.getWarehouses()
    await this.getOrders()
  }
}
</script>
